import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export function JourneyBar({ compact }) {
  const [j, setJ] = useState(null);
  useEffect(() => { api.get("/journey").then((r) => setJ(r.data)).catch(() => {}); }, []);
  if (!j) return null;
  const ap = j.assessment_progress;
  return (
    <div className="mb-6 rounded-lg border border-slate-200 bg-white p-4" data-testid="journey-bar">
      <div className="mb-3 flex flex-wrap items-center gap-2">
        <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">Compliance journey</span>
        {j.next && <Link to={j.next.path} className="ml-auto inline-flex items-center gap-1 rounded-full bg-blue-600 px-3 py-1 text-xs font-medium text-white hover:bg-blue-700" data-testid="journey-resume">Resume: {j.next.label}<ArrowRight className="h-3 w-3" /></Link>}
      </div>
      <ol className="flex flex-wrap gap-1.5">
        {j.steps.map((s, i) => (
          <li key={s.key}><Link to={s.path} data-testid={`journey-step-${s.key}`}
            className={`flex items-center gap-1 rounded-md border px-2 py-1 text-[11px] transition-colors ${s.done ? "border-emerald-200 bg-emerald-50 text-emerald-800" : j.next?.key === s.key ? "border-blue-400 bg-blue-50 text-blue-800" : "border-slate-200 text-slate-500 hover:bg-slate-50"}`}>
            {s.done ? <CheckCircle2 className="h-3 w-3" /> : <Circle className="h-3 w-3" />}{i + 1}. {s.label}</Link></li>))}
      </ol>
      {!compact && j.inventory_prompt && <div className="mt-3 rounded-md border border-amber-200 bg-amber-50 p-2 text-xs text-amber-900" data-testid="inventory-prompt">Complete your <Link to="/processing" className="font-semibold underline">Processing Inventory</Link> first — answers there make the control assessment more accurate.</div>}
      {!compact && ap && <div className="mt-2 text-[11px] text-slate-500" data-testid="journey-assessment-progress">Assessment completion {ap.completion_pct}% ({ap.completed} completed, {ap.not_applicable} N/A, {ap.skipped} skipped of {ap.total}) — completion is not the same as compliance.</div>}
    </div>
  );
}
